import { Component } from '@angular/core';
import { AppPermissions } from 'src/app/shared/app.permissions';
import { AuthorizationModel } from 'src/app/shared/models/authorization-model';

@Component({
  selector: 'ness-userprofile',
  templateUrl: './userprofile.component.html'
})
export class UserProfileComponent  {
  readonly canView: AuthorizationModel = AppPermissions.canViewUserPreferences;
}
